import { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./Form.css";
import { useLocation, useNavigate } from "react-router-dom";
import { Button } from '@mui/material';
import KeyboardArrowDownRoundedIcon from '@mui/icons-material/KeyboardArrowDownRounded';

import axios from "axios";
import { API_URL } from "../../redux/actions/api";
import { useBackIconProps } from "../../i18n/DirectionalIcons";
import Step1 from "./Steps/Step1";
import Step2 from "./Steps/Step2";
import Step3 from "./Steps/Step3";
import Step5 from "./Steps/Step5";
import Step4 from "./Steps/Step4";
import Step6 from "./Steps/Step6";
import StepFailedAppoint from "./Steps/StepFailedAppoint";
import StepIndicator from "./StepIndicator";
import { sendAppointment, startForm, fetchSiteConfig, checkSelection } from "../../redux/actions/dataActions";
import { useT } from "../../i18n";

function Form() {
  const location = useLocation();
  const t = useT();
  const backIconProps = useBackIconProps();
  const { success_visitor } = useSelector((state) => state.data)
  const { failed_visitor } = useSelector((state) => state.data)
    const { failed_visitor_error } = useSelector((state) => state.data)
  // C7 rebook: when opened from a past appointment (Appointments.js), the personal details +
  // department + service arrive via navigation state → pre-fill them and jump to the service step
  // (step 3), where Step3 auto-selects the same service. The citizen only picks a new date + time.
  const rebook = location.state?.rebook;
  const [currentStep, setCurrentStep] = useState(rebook ? 3 : 1);

  /* ★★ C2b — תור חוזר מדלג על שלב-הפרטים, ולכן השדות הנוספים אינם מוצגים.
     אם הלקוח הגדיר שדה **חובה** שלתור הישן אין לו ערך (למשל השדה נוסף אחרי
     שהתור נקבע), האזרח היה מגיע עד השליחה ורק אז חוטף שגיאת-שרת "יש למלא…"
     בלי שום מסך שבו אפשר למלא. במקרה כזה מחזירים אותו לשלב-1.
     בדיקה זולה שרצה פעם אחת, ורק בתור חוזר. */
  useEffect(() => {
    if (!rebook) { return; }
    let alive = true;
    fetchSiteConfig()(dispatch).then((cfg) => {
      if (!alive || !Array.isArray(cfg?.visitor_fields)) { return; }
      const vals = rebook.extra_fields || {};
      const missing = cfg.visitor_fields.some((f) => {
        if (!f.required) { return false; }
        const v = vals[f.key];
        return f.type === "checkbox" ? v !== "1" : !String(v ?? "").trim();
      });
      if (missing) { setCurrentStep(1); }
    });
    return () => { alive = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const [formData, setFormData] = useState({
    fname: rebook?.fname || '',
    lname: rebook?.lname || '',
    id_number: rebook?.id_number || '',
    department_id: rebook?.department_id || '',
    schedule_id: '',
    slot_data_id: '',
    appointed_time: '',
    // hint for Step3 to pre-select the same service on rebook (C7)
    _rebookScheduleId: rebook?.schedule_id || null,
    // C2b — השדות הנוספים מהתור הקודם (בתור חוזר), או ריק בקביעה רגילה.
    extra_fields: rebook?.extra_fields || {},
  })

  const navigate = useNavigate();

  const dispatch = useDispatch();

  // Floating scroll chevron for the card steps (dept / service): the .stes-warp is the
  // inner scroller, so show a hint when its content overflows (mirrors the time step).
  const stesRef = useRef(null);
  const [showScrollHint, setShowScrollHint] = useState(false);
  const checkStesScroll = () => {
    const el = stesRef.current;
    if (el) setShowScrollHint(el.scrollHeight - el.scrollTop - el.clientHeight > 8);
  };
  useEffect(() => {
    // a new step reuses the same .stes-warp element — reset its scroll to the top so the
    // list doesn't stay scrolled-down from where Step 1's keyboard pushed it.
    const el = stesRef.current;
    if (el) el.scrollTop = 0;
    const raf = requestAnimationFrame(checkStesScroll);
    return () => cancelAnimationFrame(raf);
  }, [currentStep]);
  useEffect(() => {
    // recompute on rotation / URL-bar (which resizes the locked visible height) and on
    // async content growth (Step3 loads services after mount → the list gets taller)
    const onResize = () => checkStesScroll();
    window.addEventListener('resize', onResize);
    if (window.visualViewport) window.visualViewport.addEventListener('resize', onResize);
    let ro;
    const el = stesRef.current;
    if (el && 'ResizeObserver' in window) {
      ro = new ResizeObserver(() => checkStesScroll());
      ro.observe(el);
      if (el.firstElementChild) ro.observe(el.firstElementChild);
    }
    return () => {
      window.removeEventListener('resize', onResize);
      if (window.visualViewport) window.visualViewport.removeEventListener('resize', onResize);
      if (ro) ro.disconnect();
    };
  }, [currentStep]);
  const scrollStesDown = () => {
    const el = stesRef.current;
    if (el) el.scrollBy({ top: Math.round(el.clientHeight * 0.7), behavior: 'smooth' });
  };

  const BackFunc = () => {
    if (currentStep == 1) {
      navigate('/');
      return;
    }
      if (currentStep < 1) {
      setCurrentStep(4);
      return;
    }
     if (currentStep == 5) {
      setCurrentStep(4);
      return;
  }
    setCurrentStep(currentStep - 1);
  }

  useEffect(() => {
    dispatch(startForm());
  }, [])

  useEffect(() => {
    if (success_visitor && !failed_visitor) {
      setCurrentStep(6);
    }
  
  }, [success_visitor])
  
  useEffect(() => {
      
      if(failed_visitor) {
        
          setCurrentStep(0);
      }
  }, [failed_visitor])

  /* ══════════════════════════════════════════════════════════════════════
     C1 — החזקת השעה מרגע הבחירה ועד האישור.

     ★★ **הספירה מיושרת לשעון-השרת ולא לשעון-המכשיר.** ה-API מחזיר `now`
        לצד `expires_at`, ומהם נגזר ההפרש; מכשיר עם שעון מוסט בדקות (נפוץ
        מאוד בטלפונים) היה מציג ספירה שגויה לחלוטין, ואף מסיים אותה מיד.
     ★ ההחזקה היא שכבת-נוחות: אם היא נכשלת או כבויה בהגדרות, ההזמנה ממשיכה
       כרגיל — הנכונות נאכפת בשרת ברגע האישור.
     ══════════════════════════════════════════════════════════════════════ */
  const holdTokenRef = useRef(null);
  if (!holdTokenRef.current) {
    // מזהה אקראי לדפדפן הזה. תואם לתבנית שהשרת מאמת ([A-Za-z0-9_-]{8,64}).
    holdTokenRef.current =
      'h' + Math.random().toString(36).slice(2) + Date.now().toString(36);
  }
  const [holdEndsAt, setHoldEndsAt] = useState(null);   // חותמת-זמן מקומית
  const [holdLeft, setHoldLeft] = useState(0);          // שניות שנותרו
  const [holdExpired, setHoldExpired] = useState(false);

  const releaseHold = (useBeacon) => {
    setHoldEndsAt(null);
    const url = `${API_URL}visitors/release-hold`;
    const body = new URLSearchParams({ hold_token: holdTokenRef.current });
    try {
      /* ⚠️ בסגירת-דף אין זמן לבקשה רגילה — הדפדפן קוטע אותה. `sendBeacon`
         נועד בדיוק לזה. אם אינו נתמך, ההחזקה תפוג מעצמה ממילא. */
      if (useBeacon && navigator.sendBeacon) {
        navigator.sendBeacon(url, body);
      } else {
        axios.post(url, body).catch(() => {});
      }
    } catch (e) { /* שחרור הוא אופטימיזציה — כישלון בו אינו משנה נכונות */ }
  };

  const takeHold = async (slotDataId, appointedTime) => {
    try {
      const body = new URLSearchParams({
        slot_data_id: String(slotDataId),
        appointed_time: String(appointedTime),
        hold_token: holdTokenRef.current,
      });
      const res = await axios.post(`${API_URL}visitors/hold`, body);
      /* ⚠️⚠️ **ה-API עוטף כל תשובה ב-`data`.** ‏`sendAppointment` קורא
         `res.data.data.error`, וכך גם כאן. הגרסה הראשונה קראה `res.data.ok`,
         קיבלה `undefined` על **כל** בקשה מוצלחת, והציגה "השעה נתפסה" בכל
         שעה שנבחרה — כלומר הפיצ'ר חסם את כל ההזמנות. */
      const d = (res?.data?.data ?? res?.data) || {};
      /* ★★ **פייל-אופן, ולא פייל-קלוז'ד.**
         חוסמים את האזרח **אך ורק** כשהשרת אמר במפורש `reason === 'full'`.
         כל תשובה אחרת — פיצ'ר מכובה, 401 שנתפס ע"י interceptor, תקלת-רשת,
         או גוף-תשובה שאינו מה שציפינו — פירושה "אין מידע", ולא "תפוס".
         ⚠️ הגרסה הראשונה בדקה `if (!d.ok)`, ולכן **כל** תשובה לא-צפויה
            הוצגה כ"השעה נתפסה" — וכל השעות נראו תפוסות. ההחזקה היא שכבת
            נוחות; הנכונות נאכפת בשרת ברגע האישור, ולכן ספק תמיד לטובת
            המשך-התהליך. */
      if (d.enabled === false) { return { ok: true, disabled: true }; }
      if (d.ok === true) {
        setHoldExpired(false);
        setHoldEndsAt(Date.now() + Number(d.seconds || 0) * 1000);
        setHoldLeft(Number(d.seconds || 0));
        return { ok: true };
      }
      if (d.reason === 'full') { return { ok: false, reason: 'full' }; }
      return { ok: true, disabled: true };
    } catch (e) {
      // תקלת-רשת ⇒ ממשיכים בלי החזקה במקום לחסום את ההזמנה.
      return { ok: true, disabled: true };
    }
  };

  // ספירה-לאחור + פקיעה
  useEffect(() => {
    if (!holdEndsAt) { return; }
    const tick = () => {
      const left = Math.max(0, Math.round((holdEndsAt - Date.now()) / 1000));
      setHoldLeft(left);
      if (left <= 0) {
        /* ★ בפקיעה מחזירים לבחירת-שעה (שלב 4) — הזמן שנשמר נגמר, והשעה
           כבר עשויה להיות תפוסה. הצגת מסך-אישור על שעה שאינה מובטחת היא
           בדיוק ההטעיה שהפיצ'ר בא למנוע. */
        setHoldEndsAt(null);
        setHoldExpired(true);
        setCurrentStep(4);
      }
    };
    tick();
    const t = setInterval(tick, 1000);
    return () => clearInterval(t);
  }, [holdEndsAt]);

  // סגירת/רענון דף — משחררים מיד במקום להמתין לפקיעה
  useEffect(() => {
    const onLeave = () => { if (holdEndsAt) { releaseHold(true); } };
    window.addEventListener('beforeunload', onLeave);
    return () => window.removeEventListener('beforeunload', onLeave);
  }, [holdEndsAt]);

  /* ══════════════════════════════════════════════════════════════════════
     ★★★ בכל מעבר-שלב מוודאים שהמחלקה שנבחרה **עדיין** פתוחה.

     ⚠️⚠️ הבאג שזה סוגר (דיווח-משתמש 06/08/2026): רשימת המחלקות מגיעה
        מ-`user/me` ויושבת ב-redux מאז עליית-האפליקציה, ולכן אזרח שכבר היה
        **בתוך** התהליך המשיך לשלב הבא במחלקה שנסגרה זה עתה. הרשימה
        התרעננה רק אחרי F5.

     ★ **לא מעכב את הרינדור.** ה-effect רץ *אחרי* שהשלב החדש כבר צויר,
       והבדיקה מתבצעת ברקע. במסלול התקין — שהוא כמעט תמיד — האזרח לא רואה
       ולא מרגיש דבר. חסימת-המעבר עד לתשובת-שרת הייתה מוסיפה השהיה גלויה
       לכל לחיצת "הבא", בשביל מקרה-קצה נדיר.

     ★ רץ משלב 3 והלאה בלבד: בשלב 1 (פרטים) אין עדיין מחלקה, ובשלב 2 האזרח
       *בוחר* אותה מהרשימה — ולשם הוא ממילא היה מוחזר. משלב 3 ואילך הבחירה
       "נעולה", והיא זו שעלולה להתיישן.

     ★ ‏`alive` מונע פעולה על תשובה שחזרה אחרי שהאזרח כבר עבר שלב — אחרת
       בדיקה איטית שיצאה משלב 3 הייתה מקפיצה אותו החוצה משלב 5.

     ⚠️ ממוקם **אחרי** בלוק-ההחזקה בכוונה: הוא משתמש ב-`holdEndsAt`
        וב-`releaseHold`. ‏JS היה סולח גם על הסדר ההפוך (הקולבק רץ אחרי
        גוף-הרינדור), אבל קוד שנשען על כך נשבר בעריכה הבאה.
     ══════════════════════════════════════════════════════════════════════ */
  useEffect(() => {
    if (currentStep < 3 || currentStep > 5) { return; }
    if (!formData.department_id) { return; }
    let alive = true;
    checkSelection(formData.department_id, formData.schedule_id).then((r) => {
      if (!alive || r.ok) { return; }
      /* משחררים את ההחזקה לפני היציאה — אחרת השעה נשארת תפוסה עד שתפוג,
         בשביל תור שכבר לא ייקבע. */
      if (holdEndsAt) { releaseHold(false); }
      /* ★★ F1 — ההודעה מתורגמת **לפי קוד-הסיבה** ולא נלקחת כטקסט מהשרת.
         ⚠️ הבאג שזה סוגר: `r.message` מגיע מהשרת **בעברית תמיד**, ולכן אזרח
            שבחר ערבית/רוסית קיבל מסך מתורגם ובתוכו הודעה עברית.
         ★ נפילה-לאחור ל-`r.message` ואז להודעה גנרית: שרת ישן (או קוד-סיבה
           חדש שהפרונט עדיין לא מכיר) חייב להציג **משהו** ולא מסך ריק —
           עדיף הודעה בעברית מאשר בלי הודעה. */
      const key = r.reason ? `serverErrors.${r.reason}` : '';
      const translated = key ? t(key) : '';
      const notice = (translated && translated !== key)
        ? translated
        : (r.message || t('serverErrors.generic'));
      navigate('/', { replace: true, state: { notice } });
    });
    return () => { alive = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentStep, formData.department_id, formData.schedule_id]);

  const Next = () => {
    if (currentStep == 5) {
      // ה-token נשלח עם ההזמנה כדי שהשרת יזהה שזו ההחזקה **שלנו** ולא יחסום
      // אותנו בגללה, וישחרר אותה מיד אחרי שהתור נוצר.
      dispatch(sendAppointment({ ...formData, hold_token: holdTokenRef.current }))
      return;
    }
    setCurrentStep(currentStep + 1)
  }
  
    const NextForFailed = () => {
          dispatch(startForm());
        setCurrentStep(4);
    }

let hostname = window.location.hostname;
        if (hostname.startsWith("www.")) {
         hostname = hostname.substring(4); // Remove "www."
         }
 const formMap = {
        "mayanot-hasharon.anstc.com": {form_margin_top:"0px" },
        "yamim.anstc.com": {form_margin_top:"90px" },
         "miahcom.anstc.com": {form_margin_top:"90px" },
          "migdal-haemeq.anstc.com": {form_margin_top:"90px" },
          "shefaram.anstc.com": {form_margin_top:"90px" },
        "elad.anstc.com": {form_margin_top:"60px" },
               "katsrin.anstc.com": {form_margin_top:"60px" },
         "mayanotata.anstc.com":{form_margin_top:"80px" },
         "yuvallim.anstc.com":{form_margin_top:"80px" },
        };
        
        const { form_margin_top} = formMap[hostname] || {form_margin_top:"0px" };

  const CurrentStepComponent = () => {
    switch (currentStep) {
      case 1:
        return <Step1 formData={formData} setFormData={setFormData} next={Next} />;
      case 2:
        return <Step2 formData={formData} setFormData={setFormData} next={Next} />
      case 3:
        return < Step3 formData={formData} setFormData={setFormData} next={Next} />
      case 4:
        return <Step4 formData={formData} setFormData={setFormData} next={Next}
                      onHoldTime={takeHold} holdToken={holdTokenRef.current}
                      holdExpired={holdExpired} clearHoldExpired={() => setHoldExpired(false)} />
      case 5:
        return <Step5 formData={formData} setFormData={setFormData} next={Next} />
      case 6:
        return <Step6 formData={formData} setFormData={setFormData} next={Next} />
      case 0:
        return <StepFailedAppoint formData={formData} setFormData={setFormData} next={Next} next_for_failed={NextForFailed}  />  
    }
  }


  return (
    <div className="form_container" style={{marginTop:form_margin_top}}>
      {/* Back button up to and including the confirmation screen (steps 1-5) — the
          appointment is only booked once the customer presses אישור, so they must be
          able to go back from confirmation to change the time. Hidden on success (6)
          and failure (0). BackFunc maps step 5 -> 4 (back to the calendar). */}
      {currentStep >= 1 && currentStep <= 5 && (
        <Button
          aria-label={t("common.back")}
          onClick={BackFunc}
          className="back_btn"
          size="small"
          {...backIconProps}
        >
          {t("common.back")}
        </Button>
      )}
      <StepIndicator
        currentStep={currentStep}
        goToStep={(n) => { if (n < currentStep) setCurrentStep(n); }}
      />
      {/* ★ הספירה מוצגת רק במסך-האישור (5). בשלב 4 האזרח עדיין בוחר, והצגת
          שעון רצה שם הייתה לוחצת אותו בזמן שאין בכך צורך.
          ★ **מתחת למחוון-השלבים ולא מעליו** (בקשת-משתמש 23/07/2026):
            מחוון-השלבים הוא ניווט קבוע ששייך לראש-המסך, והטיימר הוא מידע
            על **השלב הנוכחי**. מעליו הוא דחף את הניווט למטה ונקרא כאילו
            הוא חלק מהכותרת. */}
      {/* ⚠️⚠️ **המקום נשמר מראש.** ההחזקה נתפסת בשלב 4 ו-`holdLeft` הופך
          חיובי רק כשהתשובה חוזרת — כלומר הטיימר "נכנס" שבריר-שנייה אחרי
          שמסך-האישור כבר צויר, ודחף את מה שסביבו (דיווח-משתמש: "המחוון זז
          מהמקום טיפה"). מיכל בגובה קבוע מרנדר תמיד בשלב 5, והתוכן בלבד
          מתחלף — אותה משפחה בדיוק כמו רעד-הכרטיס בניהול. */}
      {currentStep === 5 && (
        <div className="hold_timer_slot">
          {holdLeft > 0 && (
            <div className="hold_timer" role="status" aria-live="polite">
              <span className="hold_timer_txt">{t("steps.holdReserved")}</span>
              <b className={holdLeft <= 60 ? 'hold_timer_num is_low' : 'hold_timer_num'}>
                {Math.floor(holdLeft / 60)}:{String(holdLeft % 60).padStart(2, '0')}
              </b>
            </div>
          )}
        </div>
      )}
      <div className="stes-warp" ref={stesRef} onScroll={checkStesScroll}>
        {/* Invoke as a function, NOT <CurrentStepComponent/> — the latter is a NEW
            component type on every Form render, so React would unmount+remount the step
            (destroying a focused input → the keyboard opens then instantly closes while
            typing, once the scroll-hint state starts re-rendering Form). Calling it keeps
            the step element's identity stable, so inputs preserve focus across renders. */}
        {CurrentStepComponent()}
      </div>

      {/* floating scroll hint on the card steps (dept / service) — not step 1 (inputs /
          keyboard) and not step 4 (has its own time-list chevron) */}
      {showScrollHint && (currentStep === 2 || currentStep === 3 || currentStep === 5) && (
        <button
          type="button"
          className="stes-scroll-btn"
          onClick={scrollStesDown}
          aria-label={t("steps.scrollMoreOptions")}
        >
          <KeyboardArrowDownRoundedIcon />
        </button>
      )}
    </div>
  );
}

export default Form;
